export default class MAdapter {
  // constructor() {}
  login(param) {
    console.log("login", param);
  }
}
